export interface JobExecutionDTO {
  batchName: string;
  endTime: string; // ($date-time)
  exitStatus: string;
  exitStatusDescription: string;
  startTime: string; // ($date-time)
  status: string;
}
